import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Form, Input, Modal, Select, Tabs, Tag } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import TextArea from 'antd/lib/input/TextArea';
import { SelectSkills } from '~/components';
import {
  addRoleFamilies,
  addSubFamilies,
  updateRoleFamilies,
} from '~/store/fetchActions/fetchFamilies';
import { selectFamilies } from '~/store/selectors';
import RoleTabInput from './RoleTabInput';
import {
  humanityDescriptionArray,
  managementDescriptionArray,
  leaderDescriptionArray,
} from './descriptionData.js';

const { Option } = Select;
const { TabPane } = Tabs;

export default function AddRoleOrSubFamily({
  isVisible,
  setVisible,
  familyId,
  isRole,
  role,
  familyList,
  currentFamilyExpanded,
  familyType,
}) {
  const [type, setType] = useState('');
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { buId } = useParams();
  const { families } = useSelector(selectFamilies);
  const [technical, setTechnical] = useState([]);
  const [humanity, setHumanity] = useState([]);
  const [management, setManagement] = useState([]);
  const [leader, setLeader] = useState([]);
  const [skillObjects, setSkillObjects] = useState([]);
  const [nameRole, setNameRole] = useState();
  const [request, setRequest] = useState();
  const [hierarchy, setHierarchy] = useState();
  const [descriptionRole, setDescriptionRole] = useState();
  const [activeTab, setActiveTab] = useState('1');
  const disabled = true;
  const isSkillPower = true;

  function getSkills(item, setSkills2) {
    setSkills2(prevSkill => {
      const previousSkills = Array.isArray(prevSkill) ? prevSkill : [];
      const idExists = previousSkills.some(skill => skill.id === item.id);

      if (!idExists) {
        return { id: item.id, skills: [...previousSkills, ...item.skills] };
      }

      return { skills: [...previousSkills, ...item.skills] };
    });
  }

  function setSkills(competenceTitle, competenceName, competenceDescription) {
    return {
      name: competenceTitle,
      description: '',
      skills: competenceName.map((item, index) => {
        return {
          name: item,
          description: competenceDescription[index],
        };
      }),
    };
  }

  useEffect(() => {
    if (currentFamilyExpanded) {
      currentFamilyExpanded?.competence?.forEach(item => {
        switch (item.name) {
          case 'TÉCNICO':
            getSkills(item, setTechnical);
            break;
          case 'HUMANAS':
            getSkills(item, setHumanity);
            break;
          case 'GESTÃO':
            getSkills(item, setManagement);
            break;
          case 'LIDERANÇA':
            getSkills(item, setLeader);
            break;
          default:
            break;
        }
      });
    }
  }, [currentFamilyExpanded]);

  useEffect(() => {
    form.resetFields();
    const tecnico = [];
    const humana = [];
    const gestao = [];
    const lideranca = [];

    if (isVisible) {
      form.setFieldsValue({
        technicalName: technical?.skills?.map(item => item.name),
        humanityName: humanity?.skills?.map(item => item.name),
        managementName: management?.skills?.map(item => item.name),
        leaderName: leader?.skills?.map(item => item.name),
      });
    }

    let arrayInfo = null;
    if (role) {
      arrayInfo = role;
    } else {
      arrayInfo = currentFamilyExpanded;
    }
    if (isVisible && arrayInfo) {
      arrayInfo.competence.forEach(comp => {
        comp.skills.forEach(skill => {
          if (comp.name === 'TÉCNICO') {
            tecnico.push(skill.power);
          }
          if (comp.name === 'HUMANAS') {
            humana.push(skill.power);
          }
          if (comp.name === 'GESTÃO') {
            gestao.push(skill.power);
          }
          if (comp.name === 'LIDERANÇA') {
            lideranca.push(skill.power);
          }
        });
      });

      form.setFieldsValue({
        ...role,
        selecttechnicalName: tecnico,
        selecthumanityName: humana,
        selectmanagementName: gestao,
        selectleaderName: lideranca,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, isVisible, role]);

  const handleCancel = useCallback(() => {
    setVisible(false);
    form.resetFields();
    setType('');
  }, [setVisible, form]);

  const changeTab = missingTab => {
    switch (missingTab.name[0]) {
      case 'selecttechnicalName':
      case 'technicalName':
        setActiveTab('1');
        break;
      case 'selecthumanityName':
      case 'humanityName':
        setActiveTab('2');
        break;
      case 'selectmanagementName':
      case 'managementName':
        setActiveTab('3');
        break;
      case 'selectleaderName':
      case 'leaderName':
        setActiveTab('4');
        break;
      default:
        break;
    }
  };

  const handleChangeType = $event => {
    setType($event);
    if ($event === 'subFamily') {
      form.setFieldsValue({
        technicalName: [],
        humanityName: ['Essência', 'Atitude', 'Inspiração'],
        managementName: [
          'Conhecimento do Negócio',
          'Cultura Ágil',
          'Visão Inovadora',
        ],
        leaderName: [
          'Inteligência Emocional',
          'Líder de si mesmo',
          'Intraempreendedorismo',
        ],
        humanityDescription: humanityDescriptionArray,
        managementDescription: managementDescriptionArray,
        leaderDescription: leaderDescriptionArray,
      });
    }
  };

  const setCompetenceList = (
    selectTechnicalName,
    selectHumanityName,
    selectManagementName,
    selectLeaderName,
    hierarchyProp,
    requestType,
  ) => {
    return new Promise(() => {
      const selectedSkills = [
        {
          idFamilyCompetence: technical.id,
          skills: technical.skills.map((skill, index) => ({
            idFamilySkill: skill.id,
            power: selectTechnicalName ? selectTechnicalName[index] : '',
          })),
        },
        {
          idFamilyCompetence: humanity.id,
          skills: humanity.skills.map((skill, index) => ({
            idFamilySkill: skill.id,
            power: selectHumanityName ? selectHumanityName[index] : '',
          })),
        },
        {
          idFamilyCompetence: management.id,
          skills: management.skills.map((skill, index) => ({
            idFamilySkill: skill.id,
            power: selectManagementName ? selectManagementName[index] : '',
          })),
        },
        {
          idFamilyCompetence: leader.id,
          skills: leader.skills.map((skill, index) => ({
            idFamilySkill: skill.id,
            power: selectLeaderName ? selectLeaderName[index] : '',
          })),
        },
      ];

      setSkillObjects(selectedSkills);
      setRequest(requestType);
      setHierarchy(hierarchyProp);
    });
  };

  useEffect(() => {
    if (role && skillObjects && skillObjects.length > 0) {
      dispatch(
        updateRoleFamilies(
          nameRole,
          role.id,
          buId,
          descriptionRole,
          skillObjects,
        ),
      );
      setSkillObjects([]);
      setVisible(false);
      form.resetFields();
      return;
    }

    if (
      request === 'post' &&
      hierarchy &&
      skillObjects &&
      skillObjects.length > 0
    ) {
      dispatch(
        addRoleFamilies(
          nameRole,
          familyId,
          buId,
          descriptionRole,
          skillObjects,
          hierarchy,
        ),
      );
      setSkillObjects([]);
      setVisible(false);
      form.resetFields();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skillObjects, role, nameRole, buId, hierarchy, request, dispatch]);

  const handleOk = useCallback(
    async values => {
      setType('');

      setNameRole(values.name);
      setDescriptionRole(values.description);
      const hierarchyProp = currentFamilyExpanded.roles.length + 1;

      if (role) {
        try {
          await setCompetenceList(
            values.selecttechnicalName,
            values.selecthumanityName,
            values.selectmanagementName,
            values.selectleaderName,
          );
        } catch (error) {
          return error;
        }
      }
      if (values.selectRoleSubFamily === 'role') {
        setHierarchy(hierarchyProp);
        await setCompetenceList(
          values.selecttechnicalName,
          values.selecthumanityName,
          values.selectmanagementName,
          values.selectleaderName,
          hierarchyProp,
          'post',
        );
      } else {
        const competences = [
          setSkills(
            'TÉCNICO',
            values.technicalName,
            values.technicalDescription || ['', '', ''],
          ),
          setSkills('HUMANAS', values.humanityName, values.humanityDescription),
          setSkills(
            'GESTÃO',
            values.managementName,
            values.managementDescription,
          ),
          setSkills('LIDERANÇA', values.leaderName, values.leaderDescription),
        ];
        dispatch(
          addSubFamilies(
            values.name,
            values.skills,
            competences,
            values.description,
            familyId,
            buId,
          ),
        );
      }
      setVisible(false);
      return null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [form, familyId, buId, setVisible, role, familyList, dispatch],
  );

  return (
    <Modal
      visible={isVisible}
      title={role ? 'Editar Cargo' : 'Adicionar Cargos ou Sub-Famílias'}
      okText="Salvar"
      cancelText="Cancelar"
      data-testid="business-unit-edit-family-modal"
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Cancelar
        </Button>,
        <Button
          data-testid="edit-bu-save-btn"
          key="submit"
          type="primary"
          onClick={() => {
            form
              .validateFields()
              .then(values => {
                handleOk(values);
              })
              .catch(error => {
                // eslint-disable-next-line no-console
                console.error(error);
                const missingPower =
                  error.errorFields.find(er => er.name.length > 0) || null;
                if (missingPower) {
                  changeTab(missingPower);
                }
              });
          }}
        >
          Salvar
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" requiredMark>
        {!role ? (
          <Form.Item
            label="Tipo"
            name="selectRoleSubFamily"
            rules={[
              {
                required: true,
                message: 'Selecione um tipo.',
                whitespace: true,
              },
            ]}
          >
            <Select
              data-testid="select-role-subFamily"
              placeholder="Selecione o tipo"
              onChange={$event => handleChangeType($event)}
            >
              <Option
                data-testid="select-option-or"
                value="role"
                selected
                disabled={
                  families?.subFamiliesIds?.length > 0 ||
                  (familyType === 'subFamily' &&
                    currentFamilyExpanded?.competence?.length === 0)
                }
              >
                Cargos
              </Option>
              {!isRole ? (
                <Option
                  data-testid="select-option-and"
                  value="subFamily"
                  disabled={
                    families?.rolesIds?.length > 0 ||
                    familyType === 'role' ||
                    currentFamilyExpanded?.competence?.length > 0
                  }
                >
                  Sub-Famílias
                </Option>
              ) : (
                <></>
              )}
            </Select>
          </Form.Item>
        ) : (
          <></>
        )}
        {(type || role) && (
          <>
            <Form.Item
              label="Nome"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Nome é obrigatório.',
                  whitespace: true,
                },
              ]}
            >
              <Input
                type="text"
                data-testid="name"
                key="name"
                placeholder="Digite um nome"
              />
            </Form.Item>
            <Form.Item
              name="description"
              label="Descrição"
              rules={[
                {
                  required: true,
                  max: 1000,
                  message:
                    'A descrição é obrigatória e deve ter até 1000 caracteres',
                  whitespace: true,
                },
              ]}
            >
              <TextArea
                placeholder="Insira uma descrição"
                data-testid="tower-description-input"
                autoSize={{ minRows: 4, maxRows: 4 }}
              />
            </Form.Item>
          </>
        )}
        {type === 'subFamily' ? (
          <SelectSkills
            tagRenderFunc={({ label, ...props }) => (
              <Tag
                data-testid={`skill-${label}`}
                style={{ margin: 2 }}
                color="blue"
                {...props}
              >
                {label}
              </Tag>
            )}
            fieldLabel="Objetivos Específicos da Sub-Família"
            placeholder="Buscar objetivo específico (ex.: Análise de indicadores, React)"
            testId="select-family-skills"
            selectMode="multiple"
            fieldName="skills"
          />
        ) : (
          <></>
        )}
        {type || role ? (
          <>
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
              <TabPane tab="Técnica" key={1} forceRender>
                <>
                  <RoleTabInput
                    numberOfInputs={3}
                    label="Técnica"
                    name="technicalName"
                    nameDescription="technicalDescription"
                    disabled={disabled && type !== 'subFamily'}
                    isSkillPower={
                      isSkillPower && (role || type !== 'subFamily')
                    }
                  />
                </>
              </TabPane>
              <TabPane tab="Humanas" key={2} forceRender>
                <RoleTabInput
                  numberOfInputs={3}
                  label="Humanas"
                  name="humanityName"
                  nameDescription="humanityDescription"
                  disabled={disabled && type !== 'subFamily'}
                  isSkillPower={isSkillPower && (role || type !== 'subFamily')}
                />
              </TabPane>
              <TabPane tab="Gestão" key={3} forceRender>
                <RoleTabInput
                  numberOfInputs={3}
                  label="Gestão"
                  name="managementName"
                  nameDescription="managementDescription"
                  disabled={disabled && type !== 'subFamily'}
                  isSkillPower={isSkillPower && (role || type !== 'subFamily')}
                />
              </TabPane>
              <TabPane tab="Liderança" key={4} forceRender>
                <RoleTabInput
                  numberOfInputs={3}
                  label="Liderança"
                  name="leaderName"
                  nameDescription="leaderDescription"
                  disabled={disabled && type !== 'subFamily'}
                  isSkillPower={isSkillPower && (role || type !== 'subFamily')}
                />
              </TabPane>
            </Tabs>
          </>
        ) : (
          <></>
        )}
      </Form>
    </Modal>
  );
}

AddRoleOrSubFamily.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  familyId: PropTypes.string,
  currentFamilyExpanded: PropTypes.object,
  isRole: PropTypes.bool,
  role: PropTypes.objectOf(PropTypes.any),
  familyList: PropTypes.objectOf(PropTypes.any),
  familyType: PropTypes.string.isRequired,
};

AddRoleOrSubFamily.defaultProps = {
  familyId: '',
  currentFamilyExpanded: {},
  isRole: true,
  role: {},
  familyList: {},
};
